import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <main className="contact-page">
      <section className="contact-card">
        <div className="contact-badge">Contact</div>

        <h1> Eric Howard Dobuler</h1>
        <p className="role">CEO / Director</p>

        <div className="contact-info">
          <p>
            <span>Address</span>
            1 Borcher Ave, Yonkers, NY 10704
          </p>

          <p>
            <span>Instagram</span>
            <a
              href="https://www.instagram.com/wdhmedia.tec"
              target="_blank"
              rel="noopener noreferrer"
            >
              @wdhmedia.tec
            </a>
          </p>

          <p>
            <span>Phone</span>
            <a href="tel:+18054753211">+1 (805) 475-3211 OR +1 (914) 691-6155</a>
          </p>

          <p>
            <span>Email</span>
            <a href="mailto:abiola.lovable@gmail.com">
              ericdobulertwin26@gmail.com
            </a>
          </p>
        </div>
      </section>
    </main>
  );
};

export default Contact;